module.exports = "/_next/static/images/b8d14de12d9f02095918eb3b189a3817-cuenta-cards-lg.png.webp";